import { ICounterpartySearchResult } from '../types/interfaces';
import { TCounterpartySearch } from '../types/actions';
import { ActionTypes } from '../types/actionTypes';

const initialState = {
  searchResult: {} as ICounterpartySearchResult,
  searchValue: '',
  errors: '',
};

export default function counterpartySearchResult(state = initialState, action: TCounterpartySearch) {
  switch (action.type) {
    case ActionTypes.SET_COUNTERPARTY_SEARCH_RESULT:
      return { ...state, searchResult: { ...action.payload } };
    case ActionTypes.SET_COUNTERPARTY_SEARCH_VALUE:
      return { ...state, searchValue: action.payload };
    case ActionTypes.SET_COUNTERPARTY_ERRORS:
      return { ...state, errors: action.payload };

    default:
      return state;
  }
}
